import { P0, S, abs, arc, fillAt } from '../../geometry';

export const umbrella = {
  name: 'Umbrella',
  colors: ['#E5484D', '#161616'],
  draw(m, t) {
    let ph = 0.4 * S(t * 1.2),
      sx = 1,
      lift = 0,
      dip = 4,
      pose = P0();
    pose.rot = 3 * S(t * 1.1);
    if (m === 'happy') {
      ph = t * 6;
      pose.ty = -2 * abs(S(t * 6));
      pose.rot = 8 * S(t * 6);
    }
    // Thinking: the scallops keep travelling round, like a twirl.
    if (m === 'thinking') {
      ph = t * 3;
      pose.rot = 5 * S(t * 1.3);
    }
    if (m === 'talking') sx = 1 + 0.05 * S(t * 10);
    if (m === 'surprised') {
      lift = -5;
      dip = 6;
    }
    if (m === 'paused') {
      sx = 0.42;
      dip = 1.5;
      pose.rot = -6 + S(t * 0.7);
    }
    const top = arc(50, 50, 36, 180, 360, 13).map(([x, y]) => [
      50 + (x - 50) * sx,
      y + lift,
    ]);
    const scallop = [...Array(9)].map((_, k) => [
      50 + (36 - k * 9) * sx,
      50 + lift + dip * (0.5 + 0.5 * S(k * Math.PI + ph)),
    ]);
    return {
      strokes: [
        { c: 'a', pts: [...top, ...scallop.slice(1)], n: 34 },
        {
          c: 'b',
          pts: [
            [50, 14 + lift],
            [50, 9 + lift],
          ],
        },
        {
          c: 'b',
          pts: [
            [50, 52 + lift],
            [50, 84],
            [48, 89],
            [43, 88],
            [41, 84],
          ],
        },
      ],
      eyes: { x: 50, y: 37 + lift },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
